import * as React from 'react'

import {
  modalAnimationDuration,
  stickyAddToBagPortalClassName,
} from '../../../../../../brunswick/styles/constants'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../../../../modals/NextModal'

import { styles } from './styles'

export const StickyAddToBagModal: React.FC<{
  shouldDisplayStickyAddToBag: boolean
  children?: React.ReactNode
}> = ({ children, shouldDisplayStickyAddToBag }) => {
  return (
    <NextModal
      closeTimeoutMS={modalAnimationDuration}
      portalClassName={stickyAddToBagPortalClassName}
      isOpen={shouldDisplayStickyAddToBag}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      shouldFocusAfterRender={false}
      style={styles}
    >
      {children}
    </NextModal>
  )
}
